import { parsePhoneNumberFromString } from 'libphonenumber-js';

const digitsOnly = value => String(value || '').replace(/\D/g, '');

const looksLikeBrazilianNationalNumber = digits =>
  digits.length === 10 || digits.length === 11;

const looksLikeBrazilianE164 = digits =>
  digits.startsWith('55') && (digits.length === 12 || digits.length === 13);

/**
 * libphonenumber leaves 10-digit BR numbers (no 9th digit) unformatted.
 * 10 digits: (84) 9418-0714 · 11 digits: (84) 99418-0714
 */
export const formatBrazilianNationalNumber = nationalDigits => {
  const digits = digitsOnly(nationalDigits);
  if (digits.length === 11) {
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
  }
  if (digits.length === 10) {
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`;
  }
  return '';
};

export const parseContactPhoneNumber = value => {
  if (!value) return undefined;

  const parsed = parsePhoneNumberFromString(value);
  if (parsed) return parsed;

  const digits = digitsOnly(value);
  if (
    !looksLikeBrazilianNationalNumber(digits) &&
    !looksLikeBrazilianE164(digits)
  ) {
    return undefined;
  }

  return parsePhoneNumberFromString(value, 'BR');
};

export const formatPhoneForDisplay = value => {
  const parsed = parseContactPhoneNumber(value);
  if (parsed?.country === 'BR') {
    return (
      formatBrazilianNationalNumber(parsed.nationalNumber) ||
      parsed.formatNational()
    );
  }
  if (parsed?.country) {
    return parsed.formatNational();
  }
  return value || '';
};

/**
 * Compare phone numbers flexibly to handle format differences
 * (e.g. Brazilian 9th digit: +5587988465072 vs +558788465072)
 */
export const phonesMatch = (phoneA, phoneB) => {
  const a = digitsOnly(phoneA);
  const b = digitsOnly(phoneB);
  if (!a || !b) return false;
  if (a === b) return true;
  return a.length >= 8 && b.length >= 8 && a.slice(-8) === b.slice(-8);
};

/**
 * Check if a given inbox phone number is admin in a group.
 * @param {string} inboxPhone - The inbox phone number
 * @param {Array} members - Array of group members with contact.phone_number and role
 * @returns {boolean}
 */
export const isInboxAdminInGroup = (inboxPhone, members) => {
  if (!inboxPhone) return false;
  return members.some(
    m => phonesMatch(inboxPhone, m.contact?.phone_number) && m.role === 'admin'
  );
};
